import React from "react";
import classes from "./styles.module.scss";
import { Link } from "react-router-dom";

const ActionButton = (props) => {
    const {
        type,
        title,
        icon,
        iconColor,
        href,
        target,
        onClick,
        label,
    } = props;

    const downloadAttribute = type === "file";

    const ButtonContent = (
        <div className={classes.iconWithLabel}>
            {icon && (
                <i
                    className={icon}
                    style={{
                        color: iconColor,
                        marginRight: label ? '6px' : '0',
                    }}
                />
            )}
            {label && <span>{label}</span>}
        </div>
    );

    const baseStyle = {
        color: iconColor,
    };

    return type !== "button" ? (
        <Link
            title={title}
            target={target}
            to={href}
            download={downloadAttribute}
            className={classes.actionButton}
            style={baseStyle}
        >
            {ButtonContent}
        </Link>
    ) : (
        <button
            title={title}
            onClick={onClick}
            className={classes.actionButton}
            style={baseStyle}
        >
            {ButtonContent}
        </button>
    );
};

export default ActionButton;
